import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  id: [
    {...makeRule('请输入正确的图片流转产品ID', 'integer', 'blur', false), min: 1},
  ],
}

export let formRules = {
  name: [
    {...makeRule('请输入图片流转产品名称', 'string')},
    {...makeRule('请输入至少2个字符', 'string'), min: 2},
  ],
}



// WEBPACK FOOTER //
// ./src/views/img-flow-product/img-flow-product.rules.js